import React  from 'react';
import Select from 'react-select'
import {API_URL} from '../../../constants';
import {GenerateArrayToDropDown, GenerateArrayToDropDownWithoutZeroOpt} from '../../../functions';
import {filterOptions} from '../../../functions';
import {approveRole} from '../../../functions';
import {toast} from 'react-toastify';
import axios from 'axios';

const urlBase  = `${API_URL}`

let childInstances = {};

function UpdateState(type, key, keyChild){

    if (keyChild === undefined) 

        keyChild = 0;

        switch(type){
            case 'LineaProducto':

                if(key == null || key.length == 0){
                    this.setState({
                        value: null,
                        optionsChild : [],
                        loading: true 
                    });

                    this.setState({
                        placeholder: "Seleccione Sector"
                    });

                    return;
                }

                let _key = typeof key === "number"
                    ? key
                    : typeof key === "object"
                    ? key.hasOwnProperty("length")
                        ? typeof key[0] === "number"
                            ? String(key)
                            : key.map(v => {
                                return v.value.toString().indexOf("-") === -1 ? v.value :  v.value.split("-")[1];
                            })
                        : String(key)
                    : -1;

                return new Promise(resolve => {
                    axios.get(urlBase + 'MasterUX/'+ _key +'/0/8/1').then(response => response.data)
                    .then((data) => {
                        var option = GenerateArrayToDropDownWithoutZeroOpt(data.result.map(option => { return {value: option.nTipCodigo, label: option.sTipNombre}}));
                        let ismulti = this.state.isMulti || this.state.isMultiple;

                        if(Array.isArray(keyChild)){
                            var itemSelected = [];

                            if(keyChild.length > 0){
                                keyChild.map((item, i) => { 
                                        let dataopt = option.find(optitem => {
                                            
                                            if(item.hasOwnProperty("lpro_Id")){
                                                return optitem.value.toString() === item.lpro_Id.toString();
                                            }else if(item.hasOwnProperty("lineaProductoCodigo")){
                                                return optitem.value.toString() === item.lineaProductoCodigo.toString();
                                            }else if(item.hasOwnProperty("nLineaProductoCodigo")){
                                                return optitem.value.toString() === item.nLineaProductoCodigo.toString();
                                            }
                                        });
                                        if(dataopt) itemSelected.push(dataopt);
                                    }
                                );

                                this.setState({
                                    optionsChild : option, 
                                    value: itemSelected.length > 0 ? itemSelected : null,
                                    loading: true
                                });
                            }else{
                                this.setState({
                                    optionsChild : option, 
                                    value: null,
                                    loading: true
                                });
                            }
                        }else{
                            var itemSelected = {};
                            
                            if(keyChild !== undefined){
                                if(ismulti){
                                    itemSelected = null;
                                }else{
                                    option.map(
                                        (item, i) => { 
                                            if (item.value.toString() === keyChild.toString()) 
                                                itemSelected=item; 
                                    });
                                }
                            }

                            this.setState({
                                optionsChild : option, 
                                value: keyChild === undefined ? null : itemSelected,
                                loading: true
                            });
                        }      
                        
                    })
                    .catch(error => {
                        console.log("ERROR LineaProducto", error);
                    });
                });
            break;
            
            case 'PartidaCascada':
                if (key == null || key.length == 0) {
                    this.setState({ value: null, optionsChild: [] });
                    return;
                }
    
                let idsSectores = key.map(v => v.value);
                const url = `${urlBase}ItemUX/GetItemListXsector?sectores=${String(idsSectores)}`;
    
                return new Promise(resolve => {
                    axios.get(url).then(response => response.data)
                        .then((data) => {
                            var options = GenerateArrayToDropDownWithoutZeroOpt(data.result.map(option => { 
                                return { value: option.part_id, label: option.part_Codigo }
                            }));
                            
                            let itemSelected = [];

                            if (Array.isArray(keyChild) && keyChild.length > 0) {
                                let idsPartidasGuardadas = keyChild.map(p => p.part_Id);
                                itemSelected = options.filter(opt => idsPartidasGuardadas.includes(opt.value));
                            }

                            this.setState({ 
                                optionsChild: options, 
                                value: itemSelected.length > 0 ? itemSelected : null
                            }); 
                        })
                        .catch(error => {
                            console.error("Error al cargar Partidas por sector:", error.response || error.message || error);
                            toast.error("¡Error al cargar las Partidas!");
                        });
                });
            break;

            case 'Categoria':
                keyChild = 0;

                if(key==null || key.length==0){
                    this.setState({
                        value: [{
                            value: 0,
                            label: "Seleccione Sector",
                        }]
                    });

                    return;
                }
                let _key_0 = key.value;

                return new Promise(resolve => {
                    axios.get(urlBase + 'CategoryUX/' + _key_0).then(response => response.data)
                    .then((data) => {
                        var itemSelected = {};
                        var option = GenerateArrayToDropDown(data.result.map(option => { return {value: option.crec_Id, label: option.crec_Nombre}}));
                        option.map((item, i)=> { if (item.value.toString() === keyChild.toString()) itemSelected=item; });
                        this.setState({optionsChild : option, value: { value: itemSelected.value, label: itemSelected.label }});
                    })
                    .catch(error => {
                        console.log("ERROR Categoria", error);
                    });
                });
            break;

            default:
                break;
        }
};

class DropDownList extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            value:          [],
            id:             '',
            name:           '',
            componente :    '',
            clave:          '',
            values:         [],
            readOnly:       false,
            options:        [],
            optionsChild:   [],
            isMulti :       this.props.isMulti,
            loading:        true
        }
    }

    updateChild(child, key) {
        const childInstance = childInstances[child];
        if (childInstance) {
            let valorHijo;
            if (child === 'PartidaCascada') {
                valorHijo = this.props.valorHijoPartida;
            } else {
                valorHijo = this.props.valorHijo;
            }
            UpdateState.call(childInstance, child, key, valorHijo);
        }
    }

    handleChange(item, id, child){
        if(item && item.length>0 && item[item.length-1].value==0) return;

        if(typeof this.props.onChange === 'function'){
            var event = {target: { name: id, value: item, type: 'dropdow' }};
            this.props.onChange(event);
        }

        if (Array.isArray(child)) {
            child.forEach(c => this.updateChild(c, item));
        } else if (child) {
            this.updateChild(child, item);
        }
        this.setState({value: item});
    }

    componentDidUpdate(){
        if(this.state.loading){
            if((this.state.value !== "" && !Array.isArray(this.state.value)) || (Array.isArray(this.state.value) && this.state.value.length > 0)){
                this.setState({
                    loading: false
                });

                var event = {
                    target: { 
                        name:  this.props.id, 
                        value: this.state.value, 
                        type: 'dropdow' 
                    }
                };
    
                this.props.onChange(event);
            }
        }
    }

    componentWillMount(){
        this.LoadResourcesType(this.props.componente);
    }

    componentWillUnmount() {
    }

    LoadResourcesType(type){
        switch(type)
        {
            case 'TipoRecurso':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ResourceTypeUX/').then(response => response.data)
                    .then((data) => {

                        var itemSelected = {};
                        this.options = GenerateArrayToDropDown(data.result.map(option => { return {value: option.nTipoRecursoCodigo, label: option.sDescripcion} }));

                        this.options.filter((item)=> { if (item.value === this.props.clave) itemSelected=item; });

                        this.setState({options:this.options }, ()=> { this.setState({value: { value: itemSelected.value, label: itemSelected.label }})});
                    })
                    .catch(error => {
                        toast.error("¡Error al cargar recursos! :[Tipo de Recursos]");
                    });
                });
                break;
            case 'LineaProducto':
                return new Promise(resolve => {
                    axios.get(urlBase + 'MasterUX/0/0/8/1').then(response => response.data)
                    .then((data) => {
                        var itemSelected = {};
                        this.options = GenerateArrayToDropDownWithoutZeroOpt(data.result.map(option => { return {value: option.nTipCodigo, label: option.sTipNombre} }));
                        data.result.map((item, i)=> { if (item.nTipCodigo === this.props.clave) itemSelected=item; });
                        this.setState({
                            options:this.options }, ()=> { 
                                this.setState({
                                    value: { 
                                        value: itemSelected.nTipCodigo, 
                                        label: itemSelected.sTipNombre 
                                    }})
                                });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Linea de Productos]");
                    });
                });
                break;
            case 'Ubicacion':
                return new Promise(resolve => {
                    axios.get(urlBase + 'LocationUX/').then(response => response.data)
                    .then((data) => {

                        this.options = GenerateArrayToDropDown(data.result.map(option => ({value: option.nUbicacionCodigo, label: option.sPais})));

                        let _selected_value;

                        if(this.state.isMulti){

                            _selected_value = [];
                            let _tmp = this.props.valor.map(i => i.pais_Id);

                            this.options.map(i => {
                                if( _tmp.includes(i.value) ){
                                    _selected_value.push(i);
                                }
                            });
                        }else{
                            this.options.map(item => {
                                if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                            });
                        }

                        this.setState({options: this.options }, ()=> {
                            this.setState({value: _selected_value});
                        });
                    })
                    .catch(error => {
                        toast.error("¡Error al cargar recursos!: [Ubicación]");
                    });
                });
                break;
            case 'UbicacionFichaPais':
                    return new Promise(resolve => {
                        axios.get(urlBase + 'LocationUX/ListarPaisSinFicha').then(response => response.data)
                        .then((data) => {
                            this.options = GenerateArrayToDropDown(data.result.map(option => ({value: option.nUbicacionCodigo, label: option.nUbicacionCodigo + ' - '+ option.sPais, etiqueta: option.sPais})));
    
                            let _selected_value;
    
                            if(this.state.isMulti){
    
                                _selected_value = [];
                                let _tmp = this.props.valor.map(i => i.pais_Id);
    
                                this.options.map(i => {
                                    if( _tmp.includes(i.value) ){
                                        _selected_value.push(i);
                                    }
                                });
                            }else{
                                this.options.map(item => {
                                    if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                                });
                            }
    
                            this.setState({options: this.options }, ()=> {
                                this.setState({value: _selected_value});
                            });
                        })
                        .catch(error => {
                            toast.error("¡Error al cargar recursos!: [Ubicación]");
                        });
                    });
                    break;
            case 'Partida':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ItemUX/' + 0).then(response => response.data)
                    .then((data) => {
                        this.options = GenerateArrayToDropDown(
                            data.result.map(option => { 
                                return {value: option.part_id, label: option.part_Codigo} 
                            }));

                        let _selected_value;

                        if(this.state.isMulti){
                            _selected_value = [];
                            let _tmp = this.props.valor.map(i => i.part_Id);

                            this.options.map(i => {
                                if( _tmp.includes(i.value) ){
                                    _selected_value.push(i);
                                }
                            });
                        }
                            else{
                                this.options.map(item => {
                                    if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                                }
                                );
                        }

                        this.setState({options: this.options }, ()=> {
                            this.setState({value: _selected_value});
                        });


                        this.setState({options: this.options});

                        if(this.props.onLoad){
                            this.props.onLoad();
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        toast.error("¡Error al cargar recursos!: [Partida]");
                    });
                });
                break;
            case 'PartidaCodigo':
                return new Promise(resolve => {
                    axios.get(urlBase + 'PartidaUX/Listar').then(response => response.data)
                    .then((data) => {
                        this.options = GenerateArrayToDropDown(
                            data.result.data.map(option => { 
                                return {value: option.part_Codigo, label: option.part_Descripcion} 
                            }));

                        let _selected_value;

                        if(this.state.isMulti){

                            _selected_value = [];
                            let _tmp = this.props.valor.map(i => i.part_Codigo);

                            this.options.map(i => {
                                if( _tmp.includes(i.value) ){
                                    _selected_value.push(i);
                                }
                            });
                        }
                        else{
                            this.options.map(item => {
                                if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                            }
                            );
                        }
                        
                        this.setState({options: this.options }, ()=> {
                            this.setState({value: _selected_value});
                        });

                        this.setState({options: this.options});

                        if(this.props.onLoad){
                            this.props.onLoad();
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        toast.error("¡Error al cargar partidas!: [Partida]");
                    });
                });
                break;
            case 'PartidaId':
                return new Promise(resolve => {
                    axios.get(urlBase + 'PartidaUX/Listar').then(response => response.data)
                    .then((data) => {
                        this.options = GenerateArrayToDropDown(
                            data.result.data.map(option => { 
                                return {value: option.part_Id, label: option.part_Descripcion} 
                            }));

                        let _selected_value;

                        if(this.state.isMulti){

                            _selected_value = [];
                            let _tmp = this.props.valor.map(i => i.part_Id);

                            this.options.map(i => {
                                if( _tmp.includes(i.value) ){
                                    _selected_value.push(i);
                                }
                            });
                        }
                        else{
                            this.options.map(item => {
                                if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                            }
                            );
                        }
                        
                        this.setState({options: this.options }, ()=> {
                            this.setState({value: _selected_value});
                        });


                        this.setState({options: this.options});

                        if(this.props.onLoad){
                            this.props.onLoad();
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        toast.error("¡Error al cargar partidas!: [Partida]");
                    });
                });
                break;
            case 'Sector':
                return new Promise(resolve => {
                    axios.get(urlBase + 'MasterUX/6').then(response => response.data)
                    .then((data) => {

                        var itemsMap = [];

                        if(this.props.superAdmin){
                            itemsMap = data.result;
                        }else if(this.props.filtro !== undefined){
                            itemsMap = filterOptions(data.result, this.props.filtro);
                        }else{
                            itemsMap = data.result;
                        }

                        this.options = GenerateArrayToDropDown(itemsMap.map(option => ({value: option.nTipCodigo, label: option.sTipNombre})));
              
                        let _selected_value;
                        if(this.state.isMulti || this.state.isMultiple){
                            _selected_value = [];
                            let _tmp = this.props.valor.map(i => i.nSectorCodigo);

                            this.options.map(i => {
                                if( _tmp.includes(i.value) ){
                                    _selected_value.push(i);
                                }
                            });
                        }else{
                            this.options.map(item => {
                                if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                            });
                        }
                        
                        if (this.props.tipo && this.props.tipo !== "master") {
                            if (Array.isArray(this.props.child)) {
                                this.props.child.forEach(c => this.updateChild(c, _selected_value));
                            } else if (this.props.child) {
                                if(this.state.isMulti || this.state.isMultiple){
                                    let _tmp = _selected_value.map(i => i.value);
                                    this.updateChild(this.props.child, _tmp);
                                }else{
                                    this.updateChild(this.props.child, _selected_value.value);
                                }
                            }
                        }

                        this.setState({
                            options: this.options 
                        }, ()=> {
                            this.setState({value: _selected_value});
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Sector]");
                    });
                });
                break;
            case 'EventSector':
                return new Promise(resolve => {
                    axios.get(urlBase + 'SectorUX').then(response => response.data)
                    .then((data) => {
                        this.options = GenerateArrayToDropDown(
                            data.result.map(option => ({
                                value: this.props.id_sin_guion ===true ? option.nSectorCodigo : option.nSectorCodigo+"-"+option.sCodigoPP , 
                                label: option.sDescripcion
                            }))
                        );

                        if(this.props.filtro!==undefined){
                            this.options = filterOptions(this.options, this.props.filtro);
                        }

                        let _selected_value;
                        if(this.state.isMulti || this.state.isMultiple){
                            _selected_value = [];
                            let _tmp = this.props.valor.map(i => i.sect_Id);

                            this.options.map(i => {
                                let optValue = i.value.toString();

                                if(optValue.indexOf("-") === -1){
                                    if(_tmp.includes(i.value)){
                                        _selected_value.push(i);
                                    }
                                }else{
                                    
                                    if(_tmp.includes(Number(i.value.split("-")[0]))){
                                        _selected_value.push(i);
                                    }
                                }
                            });
                        }else{
                            this.options.map(item => {
                                if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                            });
                        }

                        if(this.props.tipo != "master" && ! this.props.id_sin_guion  ){
                            if(this.state.isMulti || this.state.isMultiple){
                                UpdateState.call(childInstances['LineaProducto'], "LineaProducto", _selected_value, this.props.valorHijo);
                            }else{
                                UpdateState.call(childInstances['LineaProducto'], "LineaProducto", _selected_value.value, this.props.valorHijo);
                            }
                        }

                        this.setState({options: this.options }, ()=> {
                            this.setState({
                                value: _selected_value
                            });
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [EventSector]");
                    });
                });
                break;
            case 'Estado':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/ESTADO-RECURSO').then(response => response.data)
                    .then((data) => {
                        var itemsMap = [];
                        var itemSelected = {};

                        if (this.props.filtro !== undefined && (Array.isArray(this.props.filtro) && this.props.filtro.length > 0)){
                            if (this.props.filtro[0].cRoles.sRolDescripcion === "997")
                            {
                                itemsMap = data.result.filter(item=> {return (item.sNomenclatura==="D")});
                            } else
                            {
                                itemsMap = data.result;
                            }
                        } else {
                            itemsMap = data.result;
                        }
                        this.options = GenerateArrayToDropDown(itemsMap.map(option => { return {value: option.sClave, label: option.sValor} }));
                        this.options.map((item, i)=> { if (item.value.toString() === this.props.valor.toString()) itemSelected=item; });
                        this.setState({options:this.options }, ()=> { this.setState({value: { value: itemSelected.value, label: itemSelected.label }})});
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Estado]");
                    });
                });
                break;
            case 'EstadoBoletin':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/ESTADO-BOLETIN').then(response => response.data)
                    .then((data) => {

                        var itemsMap = [];
                        if (this.props.metodo === "add"){
                            itemsMap = data.result.filter(item=> {return (item.sNomenclatura === "D")});
                            this.options = GenerateArrayToDropDown(itemsMap.map(option => { return {value: option.sClave, label: option.sValor} }));
                        }else{

                            if (approveRole(this.props.filtro) || this.props.valor.toString() === "A" || this.props.superAdmin){
                                itemsMap = data.result;
                            } else{
                                itemsMap = data.result.filter(item=> {return (item.sNomenclatura === "D")});
                            }

                            this.options = GenerateArrayToDropDown(itemsMap.map(option => { return {value: option.sClave, label: option.sValor} }));
                        }

                        var itemSelected = {};
                        this.options.map((item, i)=> { if (item.value.toString() === this.props.valor.toString()) itemSelected=item; });
                        this.setState({options:this.options }, () => { 
                            this.setState({
                                value: itemSelected
                            })
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Estado]");
                    });
                });
                break;
            case 'Activo':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/ACTIVO-RECURSO').then(response => response.data)
                    .then((data) => {
                        this.options = GenerateArrayToDropDown(data.result.map(option => { return {value: option.sClave, label: option.sValor} }));
                        var itemSelected = {};
                        
                        this.options.map((item, i) => { 
                            if (item.value.toString() === this.props.valor.toString()) {
                                itemSelected = item; 
                            }
                        });

                        this.setState({options:this.options }, () => { 
                            this.setState({ 
                                value: { value: itemSelected.value, label: itemSelected.label }
                            })
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Activo]");
                    });
                });
                break;
            case 'Even_Estado':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/ESTADO-EVENTO').then(response => response.data)
                    .then((data) => {
                        console.log(data);
                        this.options = GenerateArrayToDropDown(data.result.map(option => { return {value: option.sClave, label: option.sValor} }));
                        
                        var itemSelected = {};
                        if(this.props.valor){
                            this.options.map((item, i)=> { if (item.value.toString() === this.props.valor.toString()) itemSelected=item; });
                        }else{
                            itemSelected = null;
                        }

                        this.setState({options:this.options }, ()=> { 
                            if(itemSelected){
                                this.setState({
                                    value: { value: itemSelected.value, label: itemSelected.label }
                                })
                            }
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Estado]");
                    });
                });
                break;
            case 'Even_EstadoActividad':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/ESTADOACTI-EVENTO').then(response => response.data)
                    .then((data) => {
                        console.log(data);
                        this.options = GenerateArrayToDropDown(data.result.map(option => { return {value: option.sClave, label: option.sValor} }));
                        
                        var itemSelected = {};
                        if(this.props.valor){
                            this.options.map((item, i)=> { if (item.value.toString() === this.props.valor.toString()) itemSelected=item; });
                        }else{
                            itemSelected = null;
                        }

                        this.setState({options:this.options }, ()=> { 
                            if(itemSelected){
                                this.setState({
                                    value: { value: itemSelected.value, label: itemSelected.label }
                                })
                            }
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [EstadoActividad]");
                    });
                });
                break;
            case 'Even_Activo':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/ACTIVO-EVENTO').then(response => response.data)
                    .then((data) => {
                        console.log(data);

                        this.options = GenerateArrayToDropDown(data.result.map(option => { return {value: option.sClave, label: option.sValor} }));
                        var itemSelected = {};
                        this.options.map((item, i)=> { if (item.value.toString() === this.props.valor.toString()) itemSelected=item; });
                        this.setState({options:this.options }, () => { 
                            if(itemSelected){
                                this.setState({value: { value: itemSelected.value, label: itemSelected.label }})
                            }
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Activo]");
                    });
                });
                break;
            case 'Even_Tipo':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/TIPO_EVENTO').then(response => response.data)
                    .then((data) => {
                        let values = data.result[0].sValor.split(",");
                        this.options = GenerateArrayToDropDown(values.map(option => { return {value: option, label: option} }));
                        
                        var itemSelected = {};
                        this.options.map((item, i)=> { 
                            if (item.value.toString() === this.props.valor.toString()) 
                                itemSelected = item; 
                        });
                        
                        this.setState({options:this.options }, ()=> { 
                            this.setState({
                                value: {value: itemSelected.value, label: itemSelected.label}
                            });
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Tipo]");
                    });
                });
                break;
            case 'Tipo_asistencia':
                    return new Promise(resolve => {
                        axios.get(urlBase + 'ParameterUX/ASISTENCIA-EVENTO').then(response => response.data)
                        .then((data) => {
                            this.options = GenerateArrayToDropDown(data.result.map(option => { return {value: option.sClave, label: option.sValor} }));
                            
                            var itemSelected = {};
                            this.options.map((item, i)=> { 
                                if(this.props.valor){
                                    let valor = this.props.valor.toString().trim();
                                    if(valor === ""){
                                        valor = 0;
                                    }

                                    if (item.value.toString() === valor.toString()) 
                                    itemSelected = item; 
                                }
                            });
                            
                            this.setState({options:this.options }, ()=> { 
                                this.setState({
                                    value: {value: itemSelected.value, label: itemSelected.label}
                                });
                            });
                        })
                        .catch(error => {
                            console.log(error);
                            toast.error("¡Error al cargar recursos!: [Tipo asistencia]");
                        });
                    });
                break;
            case 'fichaProducto':
                return new Promise(resolve => {
                    axios.get(urlBase + 'FichaProductoUX/ListarTodos').then(response => response.data)
                    .then((data) => {
                        console.log(data);
                        this.options = GenerateArrayToDropDown(data.result.data.map(option => { return {value: option.productoCodigo , label: option.nombreProducto} }));

                        let _selected_value;
                        if(this.state.isMulti || this.state.isMultiple){
                            _selected_value = [];
                            let _tmp = this.props.valor.map(i => i.nProductoCodigo);

                            this.options.map(i => {
                                if( _tmp.includes(i.value) ){
                                    _selected_value.push(i);
                                }
                            });
                        }else{
                            this.options.map(item => {
                                if(item.value.toString() === this.props.valor.toString()) _selected_value = item;
                            });
                        }

                        this.setState({options:this.options }, ()=> { 
                            this.setState({
                                value: _selected_value
                            });
                        });
                    }).catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Ficha producto]");
                    });
                });
                break;
            
            case 'Recurso_Organizacion':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/RECURSOS_TIPO_ORGANIZACION').then(response => response.data)
                    .then((data) => {
                        let values = data.result[0].sValor.split(",");
                        this.options = GenerateArrayToDropDown(values.map(option => { return {value: option, label: option} }));
                        
                        var itemSelected = {};
                        this.options.map((item, i)=> { 
                            if (item.value.toString() === this.props.valor.toString()) 
                                itemSelected = item; 
                        });
                        
                        this.setState({options:this.options }, ()=> { 
                            this.setState({
                                value: {value: itemSelected.value, label: itemSelected.label}
                            });
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Tipo]");
                    });
                });
                break;
            
            case 'Recurso_OrganizacionUnidad':
                return new Promise(resolve => {
                    axios.get(urlBase + 'ParameterUX/RECURSOS_TIPO_UNIDAD_ORG').then(response => response.data)
                    .then((data) => {
                        let values = data.result[0].sValor.split(",");
                        this.options = GenerateArrayToDropDown(values.map(option => { return {value: option, label: option} }));
                        
                        var itemSelected = {};
                        this.options.map((item, i)=> { 
                            if (item.value.toString() === this.props.valor.toString()) 
                                itemSelected = item; 
                        });
                        
                        this.setState({options:this.options }, ()=> { 
                            this.setState({
                                value: {value: itemSelected.value, label: itemSelected.label}
                            });
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("¡Error al cargar recursos!: [Tipo]");
                    });
                });
                break;
           
            //jorge@exp optunidad refactorizar: a una lista generica clave-valor
       case 'Productos':
                 const urlapi = urlBase + 'FichaProductoUX/ListarTodos?sector=-1';
                 console.log(urlapi)
                return new Promise(resolve => {
                    axios.get(urlapi).then(response => response.data)
                    .then((data) => {
                        
                        if (!data.result || !Array.isArray(data.result.data)) {
                            console.error("La API de Productos no devolvió la estructura esperada (data.result.data):", data);
                            this.options = []; 
                        } else {
                            this.options = GenerateArrayToDropDown(data.result.data.map(option => ({value: option.productoCodigo, label: option.nombreProducto})));
                        }

                        let _selected_value = null; 
                        const valorActual = this.props.valor; 
                        
                        if (this.state.isMulti) {
                        _selected_value = [];
                        
                        if (valorActual !== null && valorActual !== undefined) {
                            if (Array.isArray(valorActual)) {
                                _selected_value = valorActual; 
                            }
                            else if (typeof valorActual === 'string' && valorActual !== "") {
                                const selectedLabels = valorActual.split(',');
                                _selected_value = this.options.filter(option => 
                                    selectedLabels.includes(option.label)
                                );
                            }
                         }
                         }
                        this.setState({options: this.options }, ()=> {
                            this.setState({value: _selected_value});
                        });
                    })
                    .catch(error => {
                        console.error("Error capturado en DropDown 'Productos':", error); 
                        toast.error("¡Error al cargar recursos!: [Productos..]");
                    });
                });
                break;

            default: this.options = [{label: 'Sin Opciones', value:0}]; break;
        }

    }

    render() {
        return (
        (this.props.metodo === "add" && !this.state.value) ? (
            <Select
                classNamePrefix="select"
                placeholder="Seleccione una opción de la lista"
                id={this.props.id}
                name={this.props.name}
                options={this.state.options}
                onChange={value => this.handleChange(value, this.props.id, this.props.child)}
                isSearchable={true}
                isMulti={this.state.isMulti}
            />
        ):(
            <Select
                classNamePrefix="select"
                placeholder="Seleccione una opción de la lista"
                id={this.props.id}
                name={this.props.name}
                options={this.state.options}
                value={this.state.value}
                onChange={value => this.handleChange(value, this.props.id, this.props.child)}
                isSearchable={true}
                isMulti={this.state.isMulti}
            />
        ))
    }
}

class DropDownListChild extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {
            value: this.props.isMultiple ? [] : {label: this.props.val, value: this.props.valorPadre},
            id: '',
            name:'',
            componente : '',
            clave: '',
            values: [],

            value: null,
            readOnly: false,
            parentKey: ((this.props.clavePadre === undefined) ? (0): (this.props.clavePadre)),
            optionsChild: [],
            isMulti : this.props.isMultiple ? this.props.isMultiple : false,
            loading: false,
            placeholder: this.props.placeholder ? this.props.placeholder : "Seleccione una opción de la lista"
        }
        
        childInstances[this.props.componente] = this;
    }

    handleChangeChild(item, id) {
        let newValue = null;

        if(item !== null){
            newValue = item; 
            this.setState({ value: item });
        }else{
            newValue = this.props.isMultiple ? [] : "";
            this.setState({ value: newValue });
        }

        if (typeof this.props.onChange === 'function') {
            var event = {
                target: { 
                    name: id, 
                    value: newValue, 
                    type: 'dropdow' 
                }
            };

            this.props.onChange(event);
        }
    }

    componentDidUpdate(){
        if(this.state.loading){
            if(this.state.value){
                this.setState({
                    loading: false
                });

                var event = {
                    target: { 
                        name:  this.props.id, 
                        value: this.state.value, 
                        type: 'dropdow' 
                    }
                };
    
                this.props.onChange(event);
            }
        }
    }

    render(){
        return (
            <Select
                id={this.props.id}
                name={this.props.name}
                options={this.state.optionsChild}
                placeholder="Seleccione una opción de la lista"
                
                value={this.state.value}
                onChange={value => this.handleChangeChild(value, this.props.id)}
                isMulti={this.state.isMulti}
            />
        )
    }
}

export {DropDownList, DropDownListChild}